import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-kombo-deactivate',
	templateUrl: './modal-kombo-deactivate.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export class ModalKomboDeactivateComponent implements OnInit {
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogRef = inject(MatDialogRef<ModalKomboDeactivateComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.close = this.close;
		this.vm.confirm = this.confirm;
		this.vm.decline = this.decline;
	}
	
	confirm() {
		this.vm.loading = true;
		this.restService.deleteDeleteKomboIntegration({})
			.then((res) => {
				this.angularHelperService.getWindow().location.reload();
			})
			.catch((err) => {
				console.error(err);
			});
	}
	
	decline() {
		this.close();
	}
	
	close() {
		this.dialogRef.close();
	}
	
}